module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shouye"
  }, [_c('div', {
    staticClass: "navList"
  }, _vm._l((_vm.topNavList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "navList-item",
      on: {
        "click": function($event) {
          return _vm.handleTopNav(index)
        }
      }
    }, [_c('span', {
      class: _vm.topNavIndex === index ? 'navList-item-span' : 'navList-item-span1'
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), _c('span', {
      class: _vm.topNavIndex === index ? 'navList-item-xian' : 'navList-item-xian1'
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "subNavList"
  }, [(_vm.topNavIndex === 0) ? _vm._l((_vm.navList), function(item, index) {
    return _c('div', {
      key: 'live' + index,
      staticClass: "subNavList-item",
      class: _vm.navListIndex === index ? 'subNavList-item-active' : '',
      on: {
        "click": function($event) {
          return _vm.handleNav(index)
        }
      }
    }, [_c('span', {
      class: _vm.navListIndex === index ? 'subNavList-item-span' : 'subNavList-item-span1'
    }, [_vm._v(_vm._s(item.categoryName))])])
  }) : _vm._l((_vm.videoCateList), function(item, index) {
    return _c('div', {
      key: 'video' + index,
      staticClass: "subNavList-item",
      class: _vm.videoCateIndex === index ? 'subNavList-item-active' : '',
      on: {
        "click": function($event) {
          return _vm.handleVideoCate(index)
        }
      }
    }, [_c('span', {
      class: _vm.videoCateIndex === index ? 'subNavList-item-span' : 'subNavList-item-span1'
    }, [_vm._v(_vm._s(item.categoryName))])])
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.topNavIndex === 0),
      expression: "topNavIndex===0"
    }],
    ref: "listContainer",
    staticClass: "list",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('div', {
    staticClass: "list-box"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('zbList', {
      key: index,
      attrs: {
        "data": item
      }
    })
  }), 1), _vm._v(" "), (_vm.isKong) ? _c('kong') : _vm._e()], 1), _vm._v(" "), (_vm.topNavIndex === 1) ? _c('div', {
    ref: "videoGridContainer",
    staticClass: "video-grid-wrap",
    on: {
      "scroll": _vm.handleVideoScroll
    }
  }, [(_vm.videoList.length > 0) ? _c('div', {
    staticClass: "video-grid"
  }, _vm._l((_vm.videoList), function(item, index) {
    return _c('div', {
      key: item.videoId || item.id || index,
      staticClass: "video-item",
      on: {
        "click": function($event) {
          return _vm.handlePlayVideo(item)
        }
      }
    }, [_c('img', {
      staticClass: "video-item-img",
      attrs: {
        "src": item.coverUrl
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "video-item-content"
    }, [_c('div', {
      staticClass: "video-item-content-text"
    }, [_c('span', {
      staticClass: "video-item-content-title"
    }, [_vm._v(_vm._s(item.title || ''))]), _vm._v(" "), _c('span', {
      staticClass: "video-item-content-desc"
    }, [_vm._v(_vm._s(item.nickName || ''))])]), _vm._v(" "), _c('span', {
      staticClass: "video-item-content-duration"
    }, [_vm._v(_vm._s(item.duration ? _vm.formatDuration(item.duration) : '00:00'))])])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.videoLoaded && !_vm.videoLoading && _vm.videoList.length === 0) ? _c('kong') : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-153b4e68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/shouye/shouye.vue
// module id = 997
// module chunks = 1